
import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Programs from './components/Programs';
import Achievements from './components/Achievements';
import Teachers from './components/Teachers';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Header from './components/Header';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <About />
      <Programs />
      <Achievements />
      <Teachers />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
